var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showNav)?_c('nav-bar',{attrs:{"dark":_vm.isDarkMode}}):_vm._e(),_c('v-container',{attrs:{"fluid":"","ma-0":"","pa-0":""}},[_vm._t("default")],2),(_vm.showFooter)?_c('LogoFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }